import { ThemeProvider } from "@mui/material/styles"
import { Box, Button, CircularProgress, Typography } from "@mui/material"

import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { themeBeeline } from "../../theme/theme"
import {
    OperationsContainer,
    BottomButtonContainer,
    ButtonStyle,
    ContentContainer,
    LoadingContainer,
    LoadingSx,
    TitleContainer,
  } from "./styled"

import { ROUTES_PATHS } from "../../utils/constants"
import { formatRelativeDate } from "../../utils/helpers"
import { useGetOperationsHistory } from "../../api/hooks/useGetOperationsHistory"
import OperationHistoryItem from "../../components/OperationHistoryItem"
import { setCurrentFlow, setCurrentStep } from "../../store/slices/routingSlice/routingSlice"
import { STEPS_NAME } from "../../store/slices/routingSlice/flowsSteps"


const OperationsHistory = () => {
    const { groupedOperations, handleUpdate, isLoading, restOperations } = useGetOperationsHistory()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const handleBankClick = () => {
      navigate(`/${ROUTES_PATHS.linking}`)
      dispatch(setCurrentFlow("accountLinking"))
      dispatch(setCurrentStep(STEPS_NAME.linking.linkingBankSelection))
    }
 
  return (
    <ThemeProvider theme={themeBeeline}>
      <Box sx={ContentContainer}>
        <Button variant="contained" sx={ButtonStyle} onClick={handleBankClick}>
          Изменить банк
        </Button>
        <Box sx={OperationsContainer}>
          {groupedOperations?.map((item) => (
            <Box key={Object.keys(item)[0]}>
              <Typography variant="h1" sx={TitleContainer}>
                {formatRelativeDate(Object.keys(item)[0])}
              </Typography>
              {Object.values(item)[0].map((operation) => (
                <OperationHistoryItem
                  key={operation.operationId}
                  operation={operation}
                />
              ))}
            </Box>
          ))}
          {isLoading && (
            <Box sx={LoadingContainer}>
              <CircularProgress sx={LoadingSx} />
            </Box>
          )}
        </Box>
        {restOperations > 0 && (
          <Box sx={BottomButtonContainer}>
            <Button variant="outlined" sx={ButtonStyle} onClick={handleUpdate}>
              Показать еще
            </Button>
          </Box>
        )}
      </Box>
    </ThemeProvider>
  )
}
export default OperationsHistory